import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiUrls } from '../../../common/api_urls/api_urls';
import { CookieService } from 'ngx-cookie-service';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { GlobalService } from '../../../services/common/global.service';
import { headers } from '../../../common/headers';
import { ToasterMessageService } from '../../../services/topbar-toaster/toaster-message.service';
import { ToasterService } from '../../../services/toaster/toaster.service';

const header = new HttpHeaders({ [headers.lookupHeader]: 'true' });

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  public http = inject(HttpClient);
  public cookieService = inject(CookieService);
  public globalService = inject(GlobalService);
  public toastMessage = inject(ToasterMessageService);
  public toasterService = inject(ToasterService);
  public authService = inject(AuthService);
  public isAuthenticated: string = '';

  constructor() {}

  login(username: string, password: string, isLocal: boolean, turnstileToken: string | false): Observable<string> {
    if (username && password) {
      return this.http
        .post<any>(
          apiUrls.authentication.login,
          { username, password, is_local: isLocal, turnstileToken },
          { headers: header },
        )
        .pipe(
          tap((data) => {
            if (data?.accessToken) {
              let userSettings = {
                userPermissions: data?.userPermissions,
                userInfo: data?.userInfo,
                userGroups: data?.userGroups,
              };
              this.globalService.saveUserSettings(JSON.stringify(userSettings));
              this.cookieService.deleteAll();
              this.authService.saveSessionByKey(
                this.authService.emailKey,
                username,
              );
              this.authService.saveSession(data.accessToken);
              this.authService.saveUserInfo(data.sessionKey,data.userInfo.userTypeId);
              this.authService.saveRefreshSession(data.refreshToken);
              this.isAuthenticated = 'authenticated';
            } else if (data?.session) {
              this.authService.saveSessionForSetPassword(
                data?.session,
                username,
              );
              this.isAuthenticated = 'set pasword';
            } else {
              this.isAuthenticated = 'not authenticated';
            }
            this.toastMessage.clearMessage();
            this.toasterService.clearAll();
          }),
          map(() => this.isAuthenticated),
          catchError((error) => {
            console.error('Error:', error);
            this.isAuthenticated = 'not authenticated';
            return of('not authenticated');
          }),
        );
    }
    return of('not authenticated');
  }
}
